import { restApi } from '../../../../services/Api'

function createKlios(solicitacaoId) {
  return restApi.post(`/solicitacoes/${solicitacaoId}/klios`)
}

function getKlios(solicitacaoId) {
  return restApi.get(`/solicitacoes/${solicitacaoId}/klios`)
}

function refreshResultadoKlios(solicitacaoId) {
  return restApi.get(`/solicitacoes/${solicitacaoId}/klios/refresh`)
}

function recreateKlios(solicitacaoId) {
  return restApi.post(`/solicitacoes/${solicitacaoId}/klios/recreate`)
}

const kliosRepository = {
  create: createKlios,
  fetch: getKlios,
  refreshResult: refreshResultadoKlios,
  recreate: recreateKlios
}

export default kliosRepository
